import $ from 'jquery';

export default function accordionToTabs() {
  
  function init() {
    $('#tabs').easyResponsiveTabs({
      type: 'default',
      width: 'auto',
      fit: true,
      tabidentify: 'horizontal',
      activetab_bg: '#005489',
      inactive_bg: '#eaeaea',
      active_border_color: '#1d91de',
      active_content_border_color: '#eaeaea'
    });
  }
  
  if($('#tabs').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/assets/js/accordion.js